import { reConstructionMaterialConstants } from "./constants"
import actions from "../../../actions"

const initialState = {
	isSending     : false,
	isFileSending : false,
	list          : [],
	changed       : null,
	paged         : {}
}

export default function (state = initialState, action){
	switch (action.type){
		case (reConstructionMaterialConstants.GetList.REQUEST):
		case (reConstructionMaterialConstants.getHierarchy.REQUEST):
		case (reConstructionMaterialConstants.getPaged.REQUEST):
		case (reConstructionMaterialConstants.getMaterialOrgPriceInfoPaged.REQUEST):
		case (reConstructionMaterialConstants.create.REQUEST):
		case (reConstructionMaterialConstants.delete.REQUEST):
		case (reConstructionMaterialConstants.update.REQUEST):
		case (reConstructionMaterialConstants.restore.REQUEST):
		case (reConstructionMaterialConstants.getPagedAll.REQUEST):
		case (reConstructionMaterialConstants.updateClassifier.REQUEST):
			return {
				...state,
				isSending : true,
				changed   : null
			}
		case (reConstructionMaterialConstants.GetList.SUCCESS):
			return {
				...state,
				isSending : false,
				list      : action.payload.result
			}
		case (reConstructionMaterialConstants.GetList.FAILURE):
		case (reConstructionMaterialConstants.getHierarchy.FAILURE):
		case (reConstructionMaterialConstants.getPaged.FAILURE):
		case (reConstructionMaterialConstants.getMaterialOrgPriceInfoPaged.FAILURE):
		case (reConstructionMaterialConstants.create.FAILURE):
		case (reConstructionMaterialConstants.delete.FAILURE):
		case (reConstructionMaterialConstants.update.FAILURE):
		case (reConstructionMaterialConstants.restore.FAILURE):
		case (reConstructionMaterialConstants.getPagedAll.FAILURE):
		case (reConstructionMaterialConstants.updateClassifier.FAILURE):
			return {
				...state,
				error     : action.payload,
				isSending : false
			}
		case (reConstructionMaterialConstants.CLEAR):{
			return {
				...state,
				isSending     : false,
				isFileSending : false,
				list          : [],
				changed       : null,
				paged         : {}
			}
		}
		case (reConstructionMaterialConstants.GetCharacteristicsFile.REQUEST): {
			return {
				...state,
				isFileSending: true
			}
		}
		case (reConstructionMaterialConstants.GetCharacteristicsFile.SUCCESS):
		case (reConstructionMaterialConstants.GetCharacteristicsFile.FAILURE): {
			return {
				...state,
				isFileSending: false
			}
		}
		case (reConstructionMaterialConstants.getHierarchy.SUCCESS):{
			return {
				...state,
				isSending     : false,
				hierarchyList : action.payload.result
			}
		}
		case (reConstructionMaterialConstants.create.SUCCESS):{
			return {
				...state,
				isSending : false,
				changed   : actions.create
			}
		}
		case (reConstructionMaterialConstants.delete.SUCCESS):{
			return {
				...state,
				isSending : false,
				changed   : actions.delete
			}
		}
		case (reConstructionMaterialConstants.update.SUCCESS):{
			return {
				...state,
				isSending : false,
				changed   : actions.update
			}
		}
		case (reConstructionMaterialConstants.restore.SUCCESS):{
			return {
				...state,
				isSending : false,
				changed   : actions.restore
			}
		}
		case (reConstructionMaterialConstants.updateClassifier.SUCCESS):{
			return {
				...state,
				isSending : false,
				changed   : actions.download
			}
		}
		case (reConstructionMaterialConstants.getPaged.SUCCESS):
		case (reConstructionMaterialConstants.getPagedAll.SUCCESS):
			return {
				...state,
				isSending : false,
				paged     : action.payload.result
			}
		case (reConstructionMaterialConstants.getMaterialOrgPriceInfoPaged.SUCCESS):
			return {
				...state,
				isSending          : false,
				infoMaterialList   : action.payload.result.items,
				hierarchyListCount : action.payload.result.count
			}
		default:
			return state
	}
}